import { useCallback } from "react";
import type { Promisable } from "type-fest";

import { api } from "../../../api.js";
import type { TortusAvtLaunchToken } from "./TortusEmbedSurface.js";

/**
 * Returns the `tokenProvider` the embed shells expect: a callback that fetches a
 * Tortus launch token from aspire-server. Which identity the token is minted for
 * is the endpoint's business, not this hook's.
 */
export function useTortusLaunchToken({
  formDraftId,
  patientId,
}: {
  formDraftId?: string;
  patientId?: string;
}): () => Promisable<TortusAvtLaunchToken> {
  return useCallback(async (): Promise<TortusAvtLaunchToken> => {
    const response = await api.tortusAvt.getLaunchToken({
      formDraftId,
      patientId,
    });
    return response.data;
  }, [formDraftId, patientId]);
}
